import React from 'react';
import Wrapper from './StyledPage';

export const Analysis = () => {
  return <Wrapper>Analysis</Wrapper>;
};
